module.exports = __webpack_public_path__ + "img/lottery.3a201cb6.png";